import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { ChainsSVG } from '@common_components/svg/chains.svg';

const ChainsIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} w-${size} h-${size}`} onClick={onClick}>
      <ChainsSVG/>
    </div>
  );
};

export { ChainsIcon };
